export const dynamic = 'force-dynamic'
import React from 'react'
import { Metadata } from 'next';
import PartnerLogoContainer from '@/components/PartnerLogo/PartnerLogoContainer';
import CorporateLogoContainer from '@/components/CorporateLogo/CorporateLogoContainer';
import WhyChooseUs from '@/components/WhyChooseUs/WhyChooseUs';
import Testimonial from '@/components/Testimonials/Testimonial';
import StatsCounter from '@/components/Stats/StatsCounter';
import AnimationWrapper from '@/components/AnimationWrapper/AnimationWrapper';

export const metadata: Metadata = {
  title: 'Career | TEX EXCELLENCE LIMITED',
  description: 'Career | TEX EXCELLENCE LIMITED',
}


export default async function CareerPage() {
  // const about = await fetch('https://jsonplaceholder.typicode.com/posts')
  // const aboutRes = await fetch("http://localhost:8080/api/about")
  // const aboutRes = await fetch(urls?.about)
  // const aboutData = await aboutRes.json()
  // cl("aboutData", aboutData)
  // const about = aboutData?.data[0]
  // cl("about", about);

  return (
    <div className="bg-white">
      {/* preloader */}
      {/* <div className="preloader">
        <div className="loader-ripple">
          <div />
          <div />
        </div>
      </div> */}
      {/* preloader end */}
      {/* header area */}
      {/* <header className="header"> */}
      {/* header top */}
      {/* <div className="header-top">
          <div className="shape">
            <div className="shape-1" />
            <div className="shape-2" />
          </div>
          <div className="container pe-0">
            <div className="header-top-wrap">
              <div className="header-top-left">
                <div className="header-top-list">
                  <ul>
                    <li>
                      <a href="https://live.themewild.com/cdn-cgi/l/email-protection#d4bdbab2bb94b1acb5b9a4b8b1fab7bbb9">
                        <i className="far fa-envelopes" />
                        <span
                          className="__cf_email__"
                          data-cfemail="11787f777e517469707c617d743f727e7c"
                        >
                          email
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="tel:">
                        <i className="far fa-phone-volume" /> 
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="far fa-alarm-clock" /> Sun - Fri (08AM - 10PM)
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header-top-right">
                <div className="header-top-list">
                  <a href="login">
                    <i className="far fa-sign-in" /> Login
                  </a>
                </div>
                <div className="header-top-lang">
                  <div className="dropdown">
                    <a
                      href="#"
                      className="top-lang dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i className="fal fa-globe" /> Eng
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <a className="dropdown-item" href="#">
                          English
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          German
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Russian
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Spanish
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="header-top-social">
                  <span>Follow Us: </span>
                  <a href="#">
                    <i className="fab fa-facebook" />
                  </a>
                  <a href="#">
                    <i className="fab fa-x-twitter" />
                  </a>
                  <a href="#">
                    <i className="fab fa-instagram" />
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* header top end */}
      {/* navbar */}

      {/* navbar end*/}
      {/* </header> */}
      {/* header area end */}
      {/* popup search */}
      {/* <div className="search-popup">
        <button className="close-search">
          <span className="far fa-times" />
        </button>
        <form action="#">
          <div className="form-group">
            <input
              type="search"
              name="search-field"
              className="form-control"
              placeholder="Search Here..."
              required
            />
            <button type="submit">
              <i className="far fa-search" />
            </button>
          </div>
        </form>
      </div> */}
      {/* popup search end */}
      {/* sidebar-popup */}
      {/* <div
        className="sidebar-popup offcanvas offcanvas-end"
        tabIndex={-1}
        id="sidebarPopup"
      >
        <div className="offcanvas-header">
          <a href="index-2" className="sidebar-popup-logo">
            <img src="assets/img/logo/logo.png" alt="" />
          </a>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="far fa-xmark" />
          </button>
        </div>
        <div className="sidebar-popup-wrap offcanvas-body">
          <div className="sidebar-popup-content">
            <div className="sidebar-popup-about">
              <h4>About Us</h4>
              <p>
                There are many variations of passages available sure there majority
                have suffered alteration in some form by inject humour or randomised
                words which don't look even slightly believable.
              </p>
            </div>
            <div className="sidebar-popup-contact">
              <h4>Contact Info</h4>
              <ul>
                <li>
                  <div className="icon">
                    <i className="far fa-envelope" />
                  </div>
                  <div className="content">
                    <h6>Email</h6>
                    <a href="https://live.themewild.com/cdn-cgi/l/email-protection#90f9fef6ffd0f5e8f1fde0fcf5bef3fffd">
                      <span
                        className="__cf_email__"
                        data-cfemail="543d3a323b14312c35392438317a373b39"
                      >
                        email
                      </span>
                    </a>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <i className="far fa-phone" />
                  </div>
                  <div className="content">
                    <h6>Phone</h6>
                    <a href="tel:"></a>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <i className="far fa-location-dot" />
                  </div>
                  <div className="content">
                    <h6>Address</h6>
                    <a href="#"></a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="sidebar-popup-social">
              <h4>Follow Us</h4>
              <a href="#">
                <i className="fab fa-facebook" />
              </a>
              <a href="#">
                <i className="fab fa-x-twitter" />
              </a>
              <a href="#">
                <i className="fab fa-instagram" />
              </a>
              <a href="#">
                <i className="fab fa-linkedin" />
              </a>
            </div>
          </div>
        </div>
      </div> */}
      {/* sidebar-popup end */}
      <main className="main">
        {/* breadcrumb */}
        <div
          className="site-breadcrumb"
          style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
        >
          <div className="container">
            <h2 className="breadcrumb-title">Carrer</h2>
            <ul className="breadcrumb-menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li className="active">Carrer</li>
            </ul>
          </div>
        </div>
        {/* breadcrumb end */}
        {/* about area */}
        {/* <AboutIndex /> */}
        <>
          <div className="about-area py-80 ">
            <div className="container">
              <div className="row">

                <div className="col-lg-12">
                  <AnimationWrapper animation="fade-right">
                    <div className="about-right wow fadeInUp" data-wow-delay=".25s">
                      <div className="site-heading mb-3">
                        <span className="site-title-tagline">
                          <i className="far fa-solar-panel" /> Career
                        </span>
                        <h2 className="site-title">
                          {/* {about?.title} */}
                          Your career at Tex Excellence
                          {/* We Are The <span>Best</span> &amp; <span>Expert</span> For Your{" "}
                          <span>Solution</span> */}
                        </h2>
                      </div>
                      <div className="about-text">
                        {
                          // about?.description && <div dangerouslySetInnerHTML={{ __html: about?.description }} />
                        }
                        Build the Future of Textiles with Tex Excellence.
                        Join a team where innovation meets craftsmanship. Your journey starts here.

                        At Tex Excellence, we don’t just say we’re a great place to work — our people prove it. In fact, over 90% of our team members say they’re proud to be part of our journey. And they should know: most have been with us for a decade or more, shaping excellence every step of the way.
                        Whether you're a creative thinker, a technical expert, or a driven problem-solver, there's a place for you here to grow, lead, and make a difference

                        {/* At Tex Excellence Limited, we are dedicated to manufacturing precision-engineered, high-quality, and innovative custom-designed knitting machines. Our extensive product line not only includes state-of-the-art knitting machines but also offers OEM parts, expert technical service, and fabric design consultation across North America, Mexico, Central America, and South America. Our fabric range encompasses a wide array of applications, including T-shirts, fleece wear, sportswear, casual wear, industrial fabrics, medical fabrics, and packaging fabrics. */}
                        {/* <br />
                    Through our unwavering commitment to excellence, we have consistently pursued total customer satisfaction. This dedication is demonstrated daily through our teamwork, drive, and the meticulous work ethic of our employees, who strive for precision in every project.
                    <br />
                    As the premier creator of large-diameter circular knitting machines in North America, our highly skilled engineering team continually invests in research and development to perfect and modernize our knitting technology. With offices in Mexico, Honduras, Colombia, and Brazil, we boast the largest presence of any machine manufacturer in the western hemisphere. Alongside our partners, we have representatives worldwide, ensuring that Tex Excellence Limited remains at the forefront of the knitting industry. */}
                      </div>
                      {/* <div className="about-content">
                        <div className="row g-3">
                        </div>
                      </div> */}
                      <a href="/about" className="theme-btn mt-4">
                        About Us
                        <i className="fas fa-arrow-right" />
                      </a>
                    </div>
                  </AnimationWrapper>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* <AnimationWrapper animation="fade-right"></AnimationWrapper>
                <AnimationWrapper animation="fade-left" delay={0.2}></AnimationWrapper>
                <AnimationWrapper animation="fade-up" duration={1}></AnimationWrapper> */}
          </div>
        </>
        <>
          <div className="about-area py-40 ">
            <div className="container">
              <div className="row">

                <div className="col-lg-12">
                  <AnimationWrapper animation="fade-right">
                    <div className="about-right wow fadeInUp" data-wow-delay=".25s">
                      <div className="site-heading mb-3">
                        <span className="site-title-tagline">
                          <i className="far fa-solar-panel" /> Why We?
                        </span>
                        <h2 className="site-title">
                          {/* {about?.title} */}
                          Why Work With Us
                          {/* We Are The <span>Best</span> &amp; <span>Expert</span> For Your{" "}
                          <span>Solution</span> */}
                        </h2>
                      </div>
                      <div className="about-text">
                        {
                          // about?.description && <div dangerouslySetInnerHTML={{ __html: about?.description }} />
                        }
                        At Tex Excellence, we don’t just manufacture textiles — we weave excellence into everything we do. From sustainable practices to cutting-edge design, we’re shaping the future of the industry.
                        Whether you're a seasoned expert or just starting out, we believe in nurturing talent, celebrating diversity, and growing together.

                        {/* At Tex Excellence Limited, we are dedicated to manufacturing precision-engineered, high-quality, and innovative custom-designed knitting machines. Our extensive product line not only includes state-of-the-art knitting machines but also offers OEM parts, expert technical service, and fabric design consultation across North America, Mexico, Central America, and South America. Our fabric range encompasses a wide array of applications, including T-shirts, fleece wear, sportswear, casual wear, industrial fabrics, medical fabrics, and packaging fabrics. */}
                        {/* <br />
                    Through our unwavering commitment to excellence, we have consistently pursued total customer satisfaction. This dedication is demonstrated daily through our teamwork, drive, and the meticulous work ethic of our employees, who strive for precision in every project.
                    <br />
                    As the premier creator of large-diameter circular knitting machines in North America, our highly skilled engineering team continually invests in research and development to perfect and modernize our knitting technology. With offices in Mexico, Honduras, Colombia, and Brazil, we boast the largest presence of any machine manufacturer in the western hemisphere. Alongside our partners, we have representatives worldwide, ensuring that Tex Excellence Limited remains at the forefront of the knitting industry. */}
                      </div>
                      {/* <div className="about-content">
                        <div className="row g-3">
                        </div>
                      </div> */}
                      <a href="/about" className="theme-btn mt-4">
                        About Us
                        <i className="fas fa-arrow-right" />
                      </a>
                    </div>
                  </AnimationWrapper>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* <AnimationWrapper animation="fade-right"></AnimationWrapper>
                <AnimationWrapper animation="fade-left" delay={0.2}></AnimationWrapper>
                <AnimationWrapper animation="fade-up" duration={1}></AnimationWrapper> */}
          </div>
        </>
        {/* about area end */}
        {/* counter area */}
        <div className="pt-20">

          <AnimationWrapper animation="fade-up" >
            <StatsCounter />
          </AnimationWrapper>
        </div>
        <>
          <div className="about-area py-80 ">
            <div className="container">
              <div className="row">

                <div className="col-lg-12">
                  <AnimationWrapper animation="fade-right">
                    <div className="about-right wow fadeInUp" data-wow-delay=".25s">
                      <div className="site-heading mb-3">
                        <span className="site-title-tagline">
                          <i className="far fa-solar-panel" /> Career Opportunities
                        </span>
                        <h2 className="site-title">
                          {/* {about?.title} */}
                          Your career at Tex Excellence
                          {/* We Are The <span>Best</span> &amp; <span>Expert</span> For Your{" "}
                          <span>Solution</span> */}
                        </h2>
                      </div>
                      <div className="about-text">
                        {
                          // about?.description && <div dangerouslySetInnerHTML={{ __html: about?.description }} />
                        }
                        Build the Future of Textiles with Tex Excellence.
                        Join a team where innovation meets craftsmanship. Your journey starts here.

                        At Tex Excellence, we don’t just say we’re a great place to work — our people prove it. In fact, over 90% of our team members say they’re proud to be part of our journey. And they should know: most have been with us for a decade or more, shaping excellence every step of the way.
                        Whether you're a creative thinker, a technical expert, or a driven problem-solver, there's a place for you here to grow, lead, and make a difference

                        {/* At Tex Excellence Limited, we are dedicated to manufacturing precision-engineered, high-quality, and innovative custom-designed knitting machines. Our extensive product line not only includes state-of-the-art knitting machines but also offers OEM parts, expert technical service, and fabric design consultation across North America, Mexico, Central America, and South America. Our fabric range encompasses a wide array of applications, including T-shirts, fleece wear, sportswear, casual wear, industrial fabrics, medical fabrics, and packaging fabrics. */}
                        {/* <br />
                    Through our unwavering commitment to excellence, we have consistently pursued total customer satisfaction. This dedication is demonstrated daily through our teamwork, drive, and the meticulous work ethic of our employees, who strive for precision in every project.
                    <br />
                    As the premier creator of large-diameter circular knitting machines in North America, our highly skilled engineering team continually invests in research and development to perfect and modernize our knitting technology. With offices in Mexico, Honduras, Colombia, and Brazil, we boast the largest presence of any machine manufacturer in the western hemisphere. Alongside our partners, we have representatives worldwide, ensuring that Tex Excellence Limited remains at the forefront of the knitting industry. */}
                      </div>
                      {/* <div className="about-content">
                        <div className="row g-3">
                        </div>
                      </div> */}
                      <a href="/about" className="theme-btn mt-4">
                        About Us
                        <i className="fas fa-arrow-right" />
                      </a>
                    </div>
                  </AnimationWrapper>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* <AnimationWrapper animation="fade-right"></AnimationWrapper>
                <AnimationWrapper animation="fade-left" delay={0.2}></AnimationWrapper>
                <AnimationWrapper animation="fade-up" duration={1}></AnimationWrapper> */}
          </div>
        </>
        {/* counter area end */}
        {/* team-area */}
        {/* <TeamMembers /> */}
        <AnimationWrapper animation="fade-up"><PartnerLogoContainer /></AnimationWrapper>
        {/* team-area end */}
        {/* testimonial-area */}
        <Testimonial />
        {/* <div className="testimonial-area tm-bg pt-80 pb-60">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="site-heading wow fadeInDown" data-wow-delay=".25s">
                  <span className="site-title-tagline">
                    <i className="fas fa-solar-panel" /> Testimonials
                  </span>
                  <h2 className="site-title text-white">
                    What Our Client <span>Say's</span> about us
                  </h2>
                  <p className="text-white">
                    It is a long established fact that a reader will be distracted
                    by the readable content of a page when looking at its layout.
                    All the generators on the Internet tend to repeat predefined
                    chunks.
                  </p>
                  <a href="contact" className="theme-btn mt-30">
                    Know More <i className="fas fa-arrow-right" />
                  </a>
                </div>
              </div>
              <div className="col-lg-8">
                <TestimonialsSlide />
              </div>
            </div>
          </div>
        </div> */}
        {/* testimonial-area end */}
        {/* choose area */}
        <WhyChooseUs />
        {/* <div className="choose-area py-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="choose-content wow fadeInUp" data-wow-delay=".25s">
                  <div className="site-heading mb-0">
                    <span className="site-title-tagline">
                      <i className="fas fa-solar-panel" /> Why Choose Us
                    </span>
                    <h2 className="site-title">
                      We deliver <span>expertise you can trust</span> our service
                    </h2>
                    <p>
                      It is a long established fact that a reader will be distracted
                      by the readable content of a page when looking at its layout.
                    </p>
                  </div>
                  <div className="choose-content-wrap">
                    <div className="choose-item">
                      <div className="choose-item-icon">
                        <img src="../assets/img/icon/money-2.svg" alt="" />
                      </div>
                      <div className="choose-item-info">
                        <h4>Affordable Cost</h4>
                        <p>
                          At Tex Excellence Limited, our mission is to assist brands, designers, and manufacturers in creating cutting-edge fabric technologies that significantly enhance the final products.
                        </p>
                      </div>
                    </div>
                    <div className="choose-item">
                      <div className="choose-item-icon">
                        <img src="../assets/img/icon/staff.svg" alt="" />
                      </div>
                      <div className="choose-item-info">
                        <h4>Our Experience Team</h4>
                        <p>
                          There are many variations of passages available the
                          majority have suffered alteration in some by injected
                          humour.
                        </p>
                      </div>
                    </div>
                    <div className="choose-item">
                      <div className="choose-item-icon">
                        <img src="../assets/img/icon/certified.svg" alt="" />
                      </div>
                      <div className="choose-item-info">
                        <h4>Certified Company</h4>
                        <p>
                          There are many variations of passages available the
                          majority have suffered alteration in some by injected
                          humour.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="choose-img wow fadeInRight" data-wow-delay=".25s">
                  <img className="img-1" src="../assets/img/choose/11.jpg" alt="" />
                  <img className="img-2" src="../assets/img/choose/22.jpg" alt="" />
                  <img className="shape" src="../assets/img/shape/pailung_logo.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* choose area end */}
        {/* partner area */}
        <div className="partner-area bg pt-50 pb-50"
          style={{
            background: "#FFFFFF"
          }}
        >
          <div className="container"

          >
            <CorporateLogoContainer />
            {/* <div className="partner-slider owl-carousel owl-theme">
              <img src="assets/img/partner/01.png" alt="thumb" />
              <img src="assets/img/partner/02.png" alt="thumb" />
              <img src="assets/img/partner/03.png" alt="thumb" />
              <img src="assets/img/partner/04.png" alt="thumb" />
              <img src="assets/img/partner/01.png" alt="thumb" />
              <img src="assets/img/partner/02.png" alt="thumb" />
              <img src="assets/img/partner/03.png" alt="thumb" />
            </div> */}
          </div>
        </div>
        {/* partner area end */}
      </main>
      {/* footer area */}

      {/* footer area end */}
      {/* scroll-top */}
      <a href="#" id="scroll-top">
        <i className="far fa-arrow-up" />
      </a>
      {/* scroll-top end */}
      {/* js */}
    </div>

  )
}

